import React, { useState, useEffect } from 'react';
import './AppBar.css';
import {
  TopAppBar,
  TopAppBarRow,
  TopAppBarSection,
  TopAppBarFixedAdjust,
  TopAppBarNavigationIcon,
} from '@rmwc/top-app-bar';
import '@rmwc/top-app-bar/styles';
import { Ripple } from '@rmwc/ripple';
import '@rmwc/ripple/styles';
import { Drawer, DrawerContent } from '@rmwc/drawer';
import '@rmwc/drawer/styles';
import { List, ListItem } from '@rmwc/list';
import '@rmwc/list/styles';
import Home from './assets/baseline_home_black_18dp.png';
import { useFlexionStore } from './Stores';
import { getText } from './Helpers';

function AppBar(props) {
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [openDrawer, setopenDrawer] = useState(false);
  const [text, settext] = useState(getText(Sprache));

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <>
      <TopAppBar className='AppBar' fixed>
        <TopAppBarRow>
          <TopAppBarSection alignStart className='StartSection'>
            {/* <TopAppBarNavigationIcon
              icon={Menu}
              className='MenuIcon'
              onClick={() => {
                setopenDrawer(!openDrawer);
              }}
            /> */}
            <TopAppBarNavigationIcon
              icon={Home}
              className='HomeButton'
              onClick={() => {
                props.onMethodeChange('H');
              }}
            />
          </TopAppBarSection>
          <Ripple>
            <TopAppBarSection
              className={props.Methode === 'D' ? 'BarSection active' : 'BarSection'}
              onClick={() => {
                props.onMethodeChange('D');
              }}
            >
              <div className='BorderLeft' />
              <div className='Sectiondiv'>{text.AppBar.DB}</div>
            </TopAppBarSection>
          </Ripple>
          <Ripple>
            <TopAppBarSection
              className={props.Methode === 'V' ? 'BarSection active' : 'BarSection'}
              onClick={() => {
                props.onMethodeChange('V');
              }}
            >
              <div className='BorderLeft' />
              <div className='Sectiondiv'>{text.AppBar.Pre}</div>
              <div className='BorderRight' />
            </TopAppBarSection>
          </Ripple>
          <Ripple>
            <TopAppBarSection
              className={props.Methode === 'M' ? 'BarSection active' : 'BarSection'}
              onClick={() => {
                props.onMethodeChange('M');
              }}
            >
              <div className='Sectiondiv'>{text.AppBar.Mult}</div>
              <div className='BorderRight' />
            </TopAppBarSection>
          </Ripple>
          <TopAppBarSection className='LogoSection' alignEnd />
        </TopAppBarRow>
      </TopAppBar>
      <TopAppBarFixedAdjust />
      <Drawer modal open={openDrawer} onClose={() => setopenDrawer(false)}>
        <DrawerContent>
          <List>
            <ListItem
              onClick={() => {
                props.onMethodeChange('D');
                setopenDrawer(false);
                window.scrollTo(0, 0);
              }}
            >
              {text.AppBar.DB}
            </ListItem>
            <ListItem
              onClick={() => {
                props.onMethodeChange('V');
                setopenDrawer(false);
                window.scrollTo(0, 0);
              }}
            >
              {text.AppBar.Pre}
            </ListItem>
            <ListItem
              onClick={() => {
                props.onMethodeChange('M');
                setopenDrawer(false);
                window.scrollTo(0, 0);
              }}
            >
              {text.AppBar.Mult}
            </ListItem>
          </List>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default AppBar;
